export default "__VITE_ASSET__C6fMf9B4__"